import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants";
import HTMLComponent from "../../../../components/HtmlComponent";
import { Table } from "react-bootstrap";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import moment from "moment";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { useRef } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const InterviewStatusReport = () => {
  const todayDate = moment().format("YYYY-MM-DD");
  const lastMonthDate = moment().subtract(1, "months").format("YYYY-MM-DD");

  const [searchTerm, setSearchTerm] = useState("");
  const [interviwerReport, setInterviewerReport] = useState([]);
  const [jobTitleList, setJobTitleList] = useState([]);
  const [hrNameList, setHRNameList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [feedback, setFeedBack] = useState([]);
  const [additionalData, setAdditionalData] = useState([]);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [filterFormData, setFilterData] = useState([
    // { label: "HR Name", value: "" },
    { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
  ]);

  const columns = {
    JobTitle: { text: "Job Title", visible: true },
    Interviewee: { text: "Interviewee", visible: true },
    Interviewer: { text: "Interviewer", visible: true },
    Source: { text: "Source", visible: true },
    CreatedByName: { text: "HR Name", visible: true },
    InterviewDate: { text: "Interview Date", align: "center", visible: true },
    InterviewTime: { text: "Interview Time", align: "center", visible: true },
    Location: { text: "Interview Mode", visible: true },
    Round: { text: "Round", align: "center", visible: true },
    OverallRating: { text: "Overall Rating", align: "center", visible: true },
    DateOfUpload: { text: "Date Of Upload", align: "center", visible: true },
    CandidateStatus: { text: "Status", visible: true },
  };
  const defaultColumns = {
    JobTitle: true,
    Interviewee: true,
    Interviewer: true,
    CreatedByName: true,
    InterviewDate: true,
    InterviewTime: true,
    Location: true,
    Round: true,
    OverallRating: true,
    CandidateStatus: true,
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Interview Status Report"));
  }, []);

  const formDatas = [
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
    { name: "Job Title", type: "Select", options: [...jobTitleList] },
    { name: "HR Name", type: "Select", options: [...hrNameList] },
  ];

  const handleChange = (e, name) => {

    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const fetchInterviewStatusReport = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}report/5?P_JobDescriptionID=${
          filterFormData.find((o) => o.label === "Job Title")
            ? filterFormData.find((o) => o.label === "Job Title").value
            : ""
        }&P_HRID=${
          filterFormData.find((o) => o.label === "HR Name")
            ? filterFormData.find((o) => o.label === "HR Name").value
            : ""
        }&P_FromDate=${
          filterFormData.find((o) => o.label === "From Date")
            ? moment(
                filterFormData.find((o) => o.label === "From Date").value
              ).format("YYYY-MM-DD")
            : lastMonthDate
        }&P_ToDate=${
          filterFormData.find((o) => o.label === "To Date")
            ? moment(
                filterFormData.find((o) => o.label === "To Date").value
              ).format("YYYY-MM-DD")
            : todayDate
        }&P_Skills=`
      );
      SetApiStatus(response?.status);
      const data = response?.data?.data?.header;
      setInterviewerReport(data);

      // Job Title List
      const JobTitleList = response?.data?.data?.jobTitle.map((tech) => ({
        value: tech.VALUE,
        label: tech.TEXT,
      }));
      setJobTitleList(JobTitleList);

      // Hr Name List
      const hrList = response?.data?.data?.hrName.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));
      setHRNameList(hrList);
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  useEffect(() => {
    fetchInterviewStatusReport();
  }, []);

  const handleGetData = () => {
    fetchInterviewStatusReport();
  };

  const [selectedFeedBackDetails, setSelectedFeedBackDetails] = useState([]);
  const handleView = async (id) => {
    setShowModal(true);
    setSelectedFeedBackDetails(id);
    try {
      const response = await GetServiceCaller(
        `${API_URL}view-interview-feedback/${id.ID}`
      );
      const FeedBackdata = response?.data?.data?.feedbacks;
      setFeedBack(FeedBackdata);
      const AdditionalData = response?.data?.data?.interview_feedback_details;
      setAdditionalData(AdditionalData);
    } catch (error) {
      console.error("Error fetching Feedback:", error);
    }
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const totalRating =
    feedback?.reduce((sum, item) => sum + item.Rating, 0) || 0;

  const tableRef = useRef(null);

  const handleDownloadPDF = () => {
    const input = tableRef.current;
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
      pdf.save("Interview_Feedback_Details.pdf");
    });
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={interviwerReport}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isFilterRequired={true}
              isActionRequired={true}
              isSorting={true}
              showIcon1={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              formDatas={formDatas}
              handleChange={handleChange}
              handleGetData={handleGetData}
              filterFormData={filterFormData}
              handleIcon1={handleView}
              icons={{
                Icon1: <i className="bi bi-eye-fill"></i>,
                Icon1Text: "View",
              }}
            />
          </div>
        </div>
        {showModal && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header d-flex justify-content-between">
                  <h3 className="heading skill-heading">
                    Interview Feedback Details
                  </h3>
                  <span className="me-2">
                    <i className="bi bi-x-lg" onClick={handleClose}></i>
                  </span>
                </div>
                {/* <button onClick={() => generatePDF(targetRef, {filename: 'page.pdf'})}>Download PDF</button> */}
                <div className=" text-end">
                  {" "}
                  <button
                    variant="success"
                    className="me-3 mt-2 custom-btn"
                    onClick={handleDownloadPDF}
                  >
                    Export as PDF
                  </button>
                </div>

                <div className="modal-body">
                  <div ref={tableRef}>
                    <div style={{ display: "flex" ,justifyContent:"space-evenly"}}>
                      <p>
                        <b className="fw-bold">Interviewer Name :</b>{" "}
                        {selectedFeedBackDetails?.Interviewer}
                      </p>
                      <p>
                        <b className="fw-bold">Status :</b>{" "}
                        {selectedFeedBackDetails?.CandidateStatus}
                      </p>
                      <p>
                        <b className="fw-bold"> Date :</b>{" "}
                        {selectedFeedBackDetails?.InterviewDate &&
                          moment(selectedFeedBackDetails?.InterviewDate).format(
                            "DD-MMM-YYYY"
                          )}
                      </p>
                    </div>
                    <div className="box-body table-responsive">
                      <table
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                        }}
                      >
                        <thead
                          style={{ backgroundColor: "#2e2e47", color: "white" }}
                          id="thcolor"
                          className="text-center container-fluid"
                        >
                          <tr>
                            <td
                              style={{ border: "1px solid black" }}
                              className="text-center col-1"
                            >
                              Sr.No.
                            </td>
                            <td
                              style={{ border: "1px solid black" }}
                              className="col-3"
                            >
                              Category
                            </td>
                            <td
                              style={{ border: "1px solid black" }}
                              className="col-3"
                            >
                              Name
                            </td>
                            <td
                              style={{ border: "1px solid black" }}
                              className="col-1"
                            >
                              Rating Out of 5
                            </td>
                            <td
                              style={{ border: "1px solid black" }}
                              className="col-4"
                            >
                              Comment
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          {feedback?.map((item, index) => (
                            <tr
                              style={{
                                backgroundColor:
                                  index % 2 === 0 ? "#f2f2f2" : "#ffffff",
                              }}
                              key={index}
                            >
                              <td
                                style={{ border: "1px solid black" }}
                                className="text-center"
                              >
                                {index + 1}
                              </td>
                              <td style={{ border: "1px solid black" }}>
                                {item.GroupCategoryLabel}
                              </td>
                              <td style={{ border: "1px solid black" }}>
                                <HTMLComponent html={item.Skills} />
                              </td>
                              <td
                                style={{ border: "1px solid black" }}
                                className="text-center "
                              >
                                {item.Rating}/5
                              </td>
                              <td style={{ border: "1px solid black" }}>
                                <HTMLComponent
                                  html={item.Comment}
                                ></HTMLComponent>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div className="row mb-3">
                          {additionalData?.EligibleNextRound === 1 && (
                            <div className="col-lg-3">
                              <dt className="me-3">Suitable For Position</dt>
                              <dd>Yes</dd>
                            </div>
                          )}

                          <div className="col-lg-3">
                            <dt className="me-3">Consider Next Round</dt>
                            <dd className="">
                              {additionalData?.EligibleNextRound === 1
                                ? "Yes"
                                : "No"}
                            </dd>
                          </div>
                          <div className="col-lg-3">
                            <dt>Overall Rating</dt>
                            <dd className="">{totalRating}/25</dd>
                          </div>
                          <div className="col-lg-3">
                            <dt>Image</dt>
                            <dd className="">
                              <a href={additionalData?.Image} target="_blank">
                                {additionalData?.ResumePath
                                  ? additionalData?.ResumePath
                                  : ""}
                              </a>
                            </dd>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-end mt-2">
                    <button className="cancel-btn me-2" onClick={handleClose}>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default InterviewStatusReport;
